/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 5669:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ GlobalDrawer)
/* harmony export */ });
class GlobalDrawer extends HTMLElement {
  constructor() {
    super();
    this.closeElements = this.querySelectorAll('[data-drawer-close]');
    this.openDrawer = this.openDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.closeAllDrawers = this.closeAllDrawers.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    window.wetheme.webcomponentRegistry.register({key: 'component-drawer'});
    window.eventBus.on('close:all:drawers', this.closeAllDrawers);
    this.closeElements.forEach((element) => {
      element.addEventListener('click', this.closeDrawer);
    });

    if (window.Shopify.designMode) {
      window.addEventListener('resize', this.handleResize);
    }
  }

  openDrawer() {
    window.eventBus.emit('close:all:drawers', this); // Close all other global drawers before opening this one
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('js-drawer-open'); // Lock scroll
    this.trapFocus();
    this.setInitialFocus();
    // Emit event when drawer opens
    window.eventBus.emit('drawer:opened', this);
  }

  setInitialFocus() {
    // The drawer is visibility:hidden until aria-hidden flips, and focus() is a no-op on
    // a hidden element, so wait for the style to apply before moving focus. This used to
    // run from transitionend, which fires once per animated property - and the drawer
    // transitions `all` - so focus landed at an unpredictable point mid-animation.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (this.getAttribute('aria-hidden') === 'true') return;
        this.getInitialFocusElement()?.focus();
      });
    });
  }

  closeDrawer() {
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('js-drawer-open'); // Unlock scroll
    // Emit event when drawer closes
    window.eventBus.emit('drawer:closed', this);
  }

  closeAllDrawers(e) {
    if (e === this) return; // Only close other drawers not this one
    this.closeDrawer();
  }

  getFocusableElements() {
    return Array.from(
      this.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')
    ).filter((element) => (
      !element.disabled &&
      element.offsetParent !== null &&
      element.getAttribute('tabindex') !== '-1' &&
      element.getAttribute('aria-hidden') !== 'true'
    ));
  }

  getInitialFocusElement() {
    return this.getFocusableElements()[0];
  }

  trapFocus() {
    // Binding only - moving focus is setInitialFocus()'s job. The handler is bound once
    // and survives the drawer contents being replaced, since it holds no node references.
    if (this.focusTrapHandler) return;
    this.focusTrapHandler = (e) => {
      if (e.key !== 'Tab') return;

      // Let the browser move focus normally, then check where it landed. Comparing the
      // active element against a computed "last focusable" is what made focus jump to the
      // close button mid-drawer: any element the list gets wrong ends the cycle early.
      // Reacting to focus actually leaving cannot produce a false positive.
      requestAnimationFrame(() => {
        if (this.getAttribute('aria-hidden') === 'true') return;
        if (this.contains(document.activeElement)) return;

        const focusableElements = this.getFocusableElements();
        if (!focusableElements.length) return;

        const wrapTarget = e.shiftKey ? focusableElements[focusableElements.length - 1] : focusableElements[0];
        wrapTarget.focus();
      });
    };
    this.addEventListener('keydown', this.focusTrapHandler);
  }

  handleResize() {
    this.classList.add('disable-transitions');
    setTimeout(() => {
      this.classList.remove('disable-transitions');
    }, 500);
  }

  disconnectedCallback() {
    if (window.Shopify.designMode) {
      window.removeEventListener('resize', this.handleResize);
    }
  }
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/* harmony import */ var _global_drawer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5669);


class CartDrawer extends _global_drawer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A {
  constructor() {
    super();
    this.dynamicContentIds = [
      'cart-header',
      'cart-body',
      'cart-footer'
    ];
    this.scrollElement = this.querySelector('[data-cart-scroll-element]');
    this.handleCartOpen = this.handleCartOpen.bind(this);
    this.handleCartUpdate = this.handleCartUpdate.bind(this);
    this.handleCartRender = this.handleCartRender.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    window.wetheme.webcomponentRegistry.register({key: 'component-cart-drawer'});
    window.eventBus.on('open:cart:drawer', this.handleCartOpen);
    window.eventBus.on('update:cart:drawer', this.handleCartUpdate);
    window.eventBus.on('render:cart:drawer', this.handleCartRender);
  }

  handleCartOpen(e) {
    /* ===== Scroll to top of the cart if necessary ===== */
    if (e?.scrollToTop && this.scrollElement) {
      this.scrollElement.scrollTo(0, 0);
    }

    /* ===== Open the drawer ===== */
    this.openDrawer();
  }

  handleCartUpdate(e) {
    if (!e) return;
    if (e.sections?.['cart-drawer']) {
      this.renderCartDrawer(e.sections['cart-drawer']);
    }
  }

  renderCartDrawer(html) {
    /* ===== Remember which control had focus before its DOM node is replaced ===== */
    const focusDescriptor = this.getFocusDescriptor();

    /* ===== Re-render cart drawer with updated content ===== */
    this.dynamicContentIds.forEach((id) => {
      const selector = `[data-cart-dynamic-content="${id}"]`;
      const updatedContent = this.getContent(html, selector);
      const targetElement = this.querySelector(selector);
      if (targetElement) {
        targetElement.innerHTML = updatedContent;
      }
    });

    /* ===== Keep the focus trap bound, then return focus to where the shopper left it ===== */
    this.trapFocus();
    this.restoreFocus(focusDescriptor);
  }

  getCartItems() {
    return Array.from(this.querySelectorAll('[data-cart-item]'));
  }

  getInitialFocusElement() {
    /* ===== Open on the first product rather than the close button ===== */
    return this.querySelector('[data-cart-item-title]') || super.getInitialFocusElement();
  }

  getFocusDescriptor() {
    /* ===== Describe the focused control so its replacement can be found after the re-render ===== */
    const activeElement = document.activeElement;
    if (!activeElement || !this.contains(activeElement)) return null;

    const cartItem = activeElement.closest('[data-cart-item]');
    if (!cartItem) return activeElement.id ? { id: activeElement.id } : { unidentified: true };

    let control = null;
    if (activeElement.matches('[data-cart-quantity-button]')) {
      control = `[data-cart-quantity-button][name="${activeElement.name}"]`;
    } else if (activeElement.matches('[data-cart-quantity-input]')) {
      control = '[data-cart-quantity-input]';
    } else if (activeElement.matches('[data-cart-remove-item]')) {
      control = '[data-cart-remove-item]';
    } else if (activeElement.matches('[data-cart-item-title]')) {
      control = '[data-cart-item-title]';
    }

    // The cart key identifies the line itself, so we can tell a quantity change
    // (line survives) from a removal (line is gone) rather than trusting position.
    return {
      key: cartItem.getAttribute('data-cart-item-key'),
      position: this.getCartItems().indexOf(cartItem),
      control
    };
  }

  restoreFocus(descriptor) {
    /* ===== Return focus to the equivalent control in the freshly rendered markup ===== */
    // A null descriptor means focus was never inside the drawer - adding to cart from
    // the product page, say - so there is nothing to restore and nothing to steal.
    if (!descriptor) return;

    if (descriptor.id) {
      document.getElementById(descriptor.id)?.focus();
    } else if (!descriptor.unidentified) {
      const cartItems = this.getCartItems();
      const sameItem = cartItems.find((element) => element.getAttribute('data-cart-item-key') === descriptor.key);

      if (sameItem) {
        // The line survived the update, so restore the exact control that was used.
        const target = (descriptor.control && sameItem.querySelector(descriptor.control))
          || sameItem.querySelector('[data-cart-item-title]');
        target?.focus();
      } else {
        // The line was removed. Focus the title of whichever line took its place: the
        // product name tells the shopper where they landed, and it avoids dropping them
        // on a quantity control that now belongs to a different product.
        const replacement = cartItems[descriptor.position] || cartItems[cartItems.length - 1];
        replacement?.querySelector('[data-cart-item-title]')?.focus();
      }
    }

    // Focus was in the drawer before the re-render, so never leave it stranded on <body>.
    if (!this.contains(document.activeElement)) {
      this.getInitialFocusElement()?.focus();
    }
  }

  async handleCartRender() {
    /* ===== Fetch cart drawer using section rendering API (rather than bundled section rendering) - needed when adding more products to the cart than are in stock ===== */
    try {
      const response = await fetch(window.Shopify.routes.root + "?sections=cart-drawer");
      const responseJson = await response.json();
      if (responseJson?.['cart-drawer']) {
        this.renderCartDrawer(responseJson['cart-drawer']);
      }
    } catch (error) {
      console.error(`Failed to fetch cart drawer:`, error);
    }
  }

  getContent(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
  }
}

customElements.define('cart-drawer', CartDrawer);
/******/ })()
;